__turbopack_context__.v({
  "body": "OLRgNa_body",
  "bodyLong": "OLRgNa_bodyLong",
  "bodyShort": "OLRgNa_bodyShort",
  "card": "OLRgNa_card",
  "content": "OLRgNa_content",
  "cta": "OLRgNa_cta",
  "ctas": "OLRgNa_ctas",
  "heading": "OLRgNa_heading",
  "image": "OLRgNa_image",
  "section": "OLRgNa_section",
  "shade": "OLRgNa_shade",
});
